import {
  useState,
  useEffect,
  createContext,
  useContext,
  useRef
} from 'react';
import authHelper from 'Utils/Helper/AuthHelpers';
import LayoutSplashScreen from 'Core/Components/Loader';

const initAuthContextPropsState = {
  auth: authHelper.getAuth(),
  saveAuth: () => {},
  currentAdmin: undefined,
  setCurrentAdmin: () => {},
  logout: () => {},
}

const AuthContext = createContext(initAuthContextPropsState);

const useAuth = () => {
  return useContext(AuthContext);
}

// ADMIN and SUPPER_ADMIN (note: matches the backend's existing typo) are both full-access
// admin accounts - normalize them to a single 'ADMIN' role for route/menu access checks.
const ADMIN_USER_TYPES = ['ADMIN', 'SUPPER_ADMIN'];
// PARTNER accounts use the partner portal, the same as USER.
const normalizeUserType = (userType) => {
  if (ADMIN_USER_TYPES.includes(userType)) return 'ADMIN';
  if (userType === 'PARTNER') return 'USER';
  return userType;
};

const AuthProvider = ({children}) => {
  const [auth, setAuth] = useState(authHelper.getToken());
  const [currentAdmin, setCurrentAdmin] = useState(undefined);
  const saveAuth = (auth) => {
    setAuth(auth)
    if (auth) {
      authHelper.setAuth(auth);
    } else {
      authHelper.clearAppStorage();
    }
  };

  const logout = () => {
    saveAuth(undefined);
    setCurrentAdmin(undefined);
  }

  return (
    <AuthContext.Provider value={{auth, saveAuth, currentAdmin, setCurrentAdmin, logout}}>
      {children}
    </AuthContext.Provider>
  )
}

const AuthInit = ({children}) => {
  const didRequest = useRef(false);
  const {auth, logout, setCurrentAdmin} = useAuth();
  const [showSplashScreen, setShowSplashScreen] = useState(true);
  // We should request user by authToken (IN OUR EXAMPLE IT'S API_TOKEN) before rendering the application
  useEffect(() => {
    const requestAdmin = async () => {
      try {
        if (!didRequest.current) {
          const adminData = authHelper.getUserInfo();
          if (adminData) {
            setCurrentAdmin(adminData);
          }
        }
      } catch (error) {
        if (!didRequest.current) {
          logout();
        }
      } finally {
        setShowSplashScreen(false);
      }

      return () => (didRequest.current = true)
    }

    if (auth) {
      requestAdmin()
    } else {
      logout();
      setShowSplashScreen(false);
    }
  }, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{children}</>
}

export {AuthProvider, AuthInit, useAuth, normalizeUserType}